import 'appkit-react/style/appkit-react.default.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Layout from './Layout';

const App = () => <Layout />;

export default App;
